<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atras</b-button>
        <b-button variant="success" class="ml-2" @click="sendObservation">Enviar Observación</b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Destino: </strong>
                <p class="">{{ datosMov.establishmentDestiny.name }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Origen: </strong>
                <p class="">{{ datosMov.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Número de documento: </strong>
                <p class="">{{ datosMov.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong v-if="datosMov.state === 'Despachado'">Despachado por: </strong>
                <strong v-else-if="datosMov.state === 'Anulado' || datosMov.state === 'Cancelado'">Anulado por: </strong>
                <strong v-else-if="datosMov.state === 'Registrado'">Registrado por: </strong>
                <p class="">{{ datosMov.state === 'Registrado' ? datosMov.userRegister.fullname : datosMov.internalRecords[datosMov.internalRecords.length - 1].userChanged.fullname }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex" v-if="datosMov.state === 'Despachado'">
                <strong>Transportado por: </strong>
                <p class="">{{ datosMov.userReceiver.fullname }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

        <!-- Inputs sobre la tabla -->
    <div class="mt-1">
    <b-card no-body class="mt-2">
      <b-card-body>
        <b-row>
          <!-- Autoparte -->
          <b-col md="12">
            <b-form-group label="Autoparte">
              <v-select
                :options="autoparts"
                label="label"
                v-model="newItem.description"
                placeholder="Seleccione una autoparte"
                :reduce="(autopart) => autopart"
                :filterable="true"
                :filter-by="customFilter"
                @input="updateQtyAvailable"
              />
            </b-form-group>
          </b-col>

          <!-- Cantidad Disponible -->
          <b-col sm="6" md="4" lg="2">
            <b-form-group label="Cantidad Disponible">
              <b-form-input type="number" :value="newItem.qtyAvailable" readonly />
            </b-form-group>
          </b-col>

          <!-- Cantidad Requerida -->
          <b-col sm="6" md="4" lg="2">
            <b-form-group label="Cantidad Requerida">
              <b-form-input
                type="number"
                v-model="newItem.requiredQty"
                @keypress="validateRequiredQty"
                placeholder="Ingrese cantidad requerida"
              />
            </b-form-group>
          </b-col>

          <b-col sm="5" md="2" class="d-flex align-items-center mt-1">
            <b-button variant="primary" @click="addRow">Agregar</b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    </div>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
              <template #cell(qty)="data">
                <b-form-input
                  type="number"
                  v-model="data.item.qty"
                  min="1"
                  @keypress="validateQtyChange($event, data.item)"
                  @input="handleQtyChange(data.item)"
                />
              </template>
              <template #cell(observation)="data">
                <b-form-input
                  v-model="data.item.observation"
                  :readonly="!data.item.isQtyEdited"
                  placeholder="Escriba la observación"
                />
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                      @change="changeSizePage"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import InternalMovement from '@/services/InternalMovement'
import InventoryService from '@/services/InventoryService'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      datosMov: null,
      details: [],
      autoparts: [],
      newItem: {
        category: null,
        description: null,
        qtyAvailable: null,
        requiredQty: null,
      },
      details: [],
      fields: [
        { key: 'autopart.uniqueCode', label: 'Codigo Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'autopart.description', label: 'Descripción', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: false },
        { key: 'observation', label: 'Observacion', sortable: false },
      ],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components:
  {
    vSelect
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getData();
      await this.loadAutoparts();
    },
    async getData() {
        const resp = await InternalMovement.getMovInternal(this.$route.params.id, this.$store)  
        
        if (resp && resp.data) { 
          this.datosMov = resp.data.internalMovement 
          this.details = resp.data.internalDetail.map((item) => ({
          ...item,
          observation: "",
          isQtyEdited: false,
        }));
        console.log("DATOS MOVIMIENTO: ", this.datosMov);
          this.totalElements = this.details.length  
        await this.loadStockForCurrentStore();
        } else {
          console.error('Error: Datos no encontrados.')
        }
    },
    async loadAutoparts() {
      const storeId = this.datosMov.establishmentOriginId;
      if (!storeId) return (this.autoparts = []);
      const resp = await InventoryService.getStockxStore(
        storeId,
        this.$store
      );
      console.log("RESPUESTA DE STOCK: ", resp);
      if (resp.data.length !== 0) {
        this.autoparts = resp.data.map((item) => ({
          label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode}  - ${item.autopart.description}`,
          autopart: item.autopart,
          qtyAvailable: item.qtyAvailable,
        }));
      } else {
        this.autoparts = [];
      }
    },

    async loadStockForCurrentStore() {
    if (!this.datosMov.establishmentOriginId) {
      console.error("No se ha definido el establecimiento.");
      return;
    }

  this.arrayFilters = [
    {
      keyContains: "establishments.id",
      key: "equals",
      value: this.datosMov.establishmentOriginId,
    },
    {
      keyContains: "autopart.originalCode",
      key: "in",
      value: this.details.map((item) => item.autopart.originalCode),
    },
    {
      keyContains: "autopart.alterCode",
      key: "in",
      value: this.details.map((item) => item.autopart.alterCode),
    },
  ];

  try {
    const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.arrayFilters)}`;
    const response = await InventoryService.getAllStocks(url, this.$store);

    if (response.data?.rows?.length > 0) {
      const stockData = response.data.rows;

      this.details.forEach((item) => {
        const stockItem = stockData.find(
          (stock) =>
            stock.autopart.originalCode === item.autopart.originalCode ||
            stock.autopart.alterCode === item.autopart.alterCode
        );
        if (stockItem) {
          item.originalQty = stockItem.qtyAvailable;
        } else {
          item.originalQty = 0;
        }
      });
    }
  } catch (error) {
    console.error("Error al obtener el stock de la tienda actual:", error);
  }
},

    updateQtyAvailable() {
      this.newItem.qtyAvailable = this.newItem.description?.qtyAvailable || 0;
    },

    validateRequiredQty(event) {
      const maxQty = parseInt(this.newItem.qtyAvailable) || 0;
      const newValue = parseInt(event.target.value + event.key) || 0;
      if (newValue > maxQty) event.preventDefault();
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    addRow() {
      const {description, requiredQty } = this.newItem;

      if ( !description || !requiredQty) {
        this.$swal("Error", "Todos los campos son obligatorios", "error");
        return;
      }

      if (requiredQty > this.newItem.qtyAvailable) {
        this.$swal("Error", "Cantidad requerida supera la cantidad disponible", "error");
        return;
      }

      const isDuplicate = this.details.some(
        (item) => item.autopart.id === description.autopart.id
      );

      if (isDuplicate) {
        this.$swal("Error", "La autoparte ya está en la lista", "error");
        return;
      }

      const newDetail = {
        autopart: {
          id: description.autopart.id,
          uniqueCode: description.autopart.uniqueCode,
          originalCode: description.autopart.originalCode,
          alterCode: description.autopart.alterCode,
          description: description.autopart.description,
        },
        qty: requiredQty,
        observation: "",
        isQtyEdited: true,
      };

      this.details.push(newDetail);

      this.newItem = { category: null, description: null, qtyAvailable: null, requiredQty: null };
    },

    async sendObservation() {
      try {
        if (!this.details.length) {
          this.$swal("Error", "No hay detalles para enviar.", "error");
          return;
        }

        const invalidItems = this.details.filter(item => item.isQtyEdited && !item.observation);
        if (invalidItems.length) {
          this.$swal(
            "Error",
            "Asegúrese de que todas las cantidades modificadas tengan una observación.",
            "error"
          );
          return;
        }

        let state = "Observado";

        const autoparts = this.details.map(item => {
        const editedQty = parseInt(item.qty);
        const originalQty = parseInt(item.originalQty);
        const qtyDifference = editedQty - originalQty;
  
        if (qtyDifference > 0 && qtyDifference > originalQty) {
          state = "Alerta";
        }

      return {
        autopartId: item.autopart.id,
        qty: editedQty,
        observation: item.observation || null,
      };
    });

    const payload = {
      establishmentOriginId: this.datosMov.establishmentOrigin.id,
      establishmentDestinyId: this.datosMov.establishmentDestiny.id,
      description: this.datosMov.description,
      documentCode: this.datosMov.documentCode,
      state,
      autoparts,
    };
    if (state === "Alerta") {
      const confirmed = await this.$swal({
        title: "Alerta de stock insuficiente",
        text: "Se detectaron cantidades que superan el stock actual del establecimiento de origen. ¿Deseas continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmed.isConfirmed) return;
    }
    const response = await InternalMovement.updateProcess(this.$route.params.id, payload, this.$store);
    if (response.error === false) {
      this.$swal("Éxito", `El movimiento se envió correctamente como "${state}".`, "success");
      this.$router.go(-1); 
    }
  } catch (error) {
    this.$swal("Error", "No se pudo enviar la observación.", "error");
  }
},

    validateQtyChange(event, item) {
      const initialQty = item.qty;
      const maxQty = initialQty + item.autopart.qtyAvailable; 
      const char = String.fromCharCode(event.keyCode || event.which);
      const newValue = parseInt((item.qty || 0).toString() + char);

      if (event.keyCode === 8 || event.keyCode === 46) {
        return true;
      }

      if (isNaN(newValue) || newValue > maxQty || newValue < 0) {
        event.preventDefault();
        return false;
      }

      return true;
    },
    handleQtyChange(item) {
      item.isQtyEdited = true;
      if (!item.observation) {
        item.observation = "";
      }
      const initialQty = item.qty || 0;
      const maxQty = initialQty + item.autopart.qtyAvailable;
    
      if (item.qty > maxQty) {
        item.qty = maxQty; 
      } else if (item.qty < 0) {
        item.qty = 0; 
      }
    },

    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      this.order = data.sortDesc ? 'desc' : 'asc'
    }
  }
}
</script>

<style></style>
